import moment, { Moment } from 'moment';

// Overloads allow typescript to recognize when the output is actually nullable.
function date(date: Moment | Date | string): string;
function date(date: null): null;
function date(date: Moment | Date | string | null): string | null;
function date(date: Moment | Date | string | null): string | null {
    if (date === null) {
        return null;
    }
    if (typeof date === 'string') {
        // Verify string is in YYYY-MM-DD format
        const datePattern = /^\d{4}-\d{2}-\d{2}$/;
        if (!datePattern.test(date)) {
            throw new Error('Date string must be in YYYY-MM-DD format');
        }
        return date;
    }
    const dateMoment = date instanceof Date ? moment(date) : date;
    return dateMoment.format('YYYY-MM-DD');
}

// Overloads allow typescript to recognize when the output is actually nullable.
function datetime(datetime: Moment | Date): string;
function datetime(datetime: null): null;
function datetime(datetime: Moment | Date | null): string | null;
function datetime(datetime: Moment | Date | null): string | null {
    if (datetime === null) {
        return null;
    }
    const datetimeMoment = datetime instanceof Date ? moment(datetime) : datetime;
    return datetimeMoment.toISOString();
}

export const GraphInputHelpers = {
    date,
    datetime,
};
